import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from "moment";

export default class ComponentToPrint extends React.Component {
    render() {
        const data = this.props.data;
        const monthlyCollectionDetails = this.props.monthlyCollectionDetails;
        const summeryValues = this.props.summeryValues;
        const subNames = this.props.contentRowNames;
        const colName = this.props.initialData;

        return (
            <div>
                <h3><center><u>Employee Norm Card Report</u></center></h3>
            <center>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {monthlyCollectionDetails.group}</div>
                    <div className="col"><b>Operation Entity: </b> {monthlyCollectionDetails.estate}</div>
                    <div className="col"><b>collection Point: </b> {monthlyCollectionDetails.collectionPoint}</div>
                    <div className="col"><b>From Date: </b> {monthlyCollectionDetails.fromDate}</div>
                    <div className="col"><b>To Date: </b> {monthlyCollectionDetails.toDate}</div>
                    <div className="col"><b>Registration Number: </b> {monthlyCollectionDetails.regNumber}</div>
                </div>
            </center>

            <center>
            </center>

            
        <div className="card shadow-none bg-light">
                            <div className="row alternative_cls bg-light  ">
                                <div className="card-body width1" style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px', marginTop: '20px' }}>
                                </div>
                               <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Date
                                                    </TableCell>
                                                    {colName.map((item) => (
                                                        <TableCell style={{ fontWeight: "bold" }} align='center'>
                                                            {item} (Kg)
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Total
                                                    </TableCell>
                                                    {
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                            Cash Kilo
                                                        </TableCell>}                                                   

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>

                                                {data.map((row) => (
                                                    <TableRow key={row.regNumber}>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>{moment(row.date).format('YYYY-MM-DD')}</TableCell>

                                                        {subNames.map((column) => {
                                                            const value = row[column];
                                                            return (
                                                                <TableCell align='right'>{value == undefined ? '-' : parseFloat(value).toFixed(2)}</TableCell>
                                                            );
                                                        })}
                                                        <TableCell align="center">{parseFloat(row.total).toFixed(2)}</TableCell>
                                                        
                                                        {
                                                        <TableCell align="center">{parseFloat(row.total) < parseFloat(row.configurationValue) / 2
                                                             ? parseFloat(row.total).toFixed(2)
                                                             : (parseFloat(row.total) - parseFloat(row.configurationValue) < 0
                                                                 ? (parseFloat(row.total) - parseFloat(row.configurationValue) / 2).toFixed(2)
                                                                 : (parseFloat(row.total) - parseFloat(row.configurationValue)).toFixed(2))}
                                                        </TableCell>
                                                
                                                        }
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                     </div> 
                </div>
            </div>
        );
    }
}